export default "__VITE_ASSET__CFRu5l1i__"